export const OUTLAW_ROUTES = {
  video: 'video',
  films: 'videos',
  playlists: 'playlists',
  channel: 'channel',
  filmmaker: 'filmmaker',
  competition: 'competition',
  chanfilcreator: 'chanfilcreator',
  search: 'search',
  settings: 'settings',
  roku: 'roku',
  watchLater: 'watch-later',
  watchHistory: 'watch-history',
  profile: 'profile',
  infoSubscriptions: 'info-subscriptions',
  onlyInTheApp: 'only-in-the-app',
  mobile: 'mobile',
  auth: {
    base: 'auth',
    registration: 'registration',
    login: 'login',
    email: 'email',
    forgotPassword: 'forgot-password',
    passwordRecovery: 'password-recovery',
    addPhone: 'add-phone',
    addNickname: 'add-nickname',
    phoneVerify: 'phone-verify',
    chooseInterests: 'choose-interests',
    follow: 'follow',
    emailVerify: 'email-verify',
  },
  coins: 'points',
  devices: 'connect-tv',
  userInfo: 'user-info',
  notFound: 'not-found',
  subscribe: 'subscribe',
  post: 'post',
};
